// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_a79680d0"};